import React, { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import DataGridComponent from "./DataGridComponent";

const DataGridCrudComponent = (props: any) => {
    const [addOrAlterTitle, setAddOrAlterTitle] = useState('Gravar'); // Adicionar');
    const [idToDelete, setIdToDelete] = useState(0);

    useEffect(() => {
        if (idToDelete == 0)
        {
            return;
        }
        
        setAddOrAlterTitle('Gravar'); // Adicionar');
        props.gridDelete(idToDelete);
        props.cancel();

        setIdToDelete(0)
    }, [idToDelete]);

    const deleteItemGrid = (id: any) => {
        setIdToDelete(id);
    };

    function cancel() {
        props.cancel();
        setAddOrAlterTitle('Gravar'); // Adicionar
    }

    const addOrAlter = (id: any) => {
        props.gridEdit(id);
        setAddOrAlterTitle('Gravar'); // Alterar');
    }

    return (
        <div className="row">
            <input type='hidden' value={props.model?.id ?? ''} />
            <input type='hidden' value={props.model?.state ?? ''} />

            {props.children}

            <div className="col-md-5 col-lg-4 col-xl-3">
                <Button
                    onClick={props.save}
                    variant="contained"
                    className="col-md-5 col-5"
                    style={{ margin: '10px 10px 10px 0' }}>{addOrAlterTitle}</Button>

                <Button
                    onClick={cancel}
                    variant="contained"
                    className="col-md-5 col-5"
                    style={{ margin: '10px 10px 10px 0' }}>{props.labelCancelar ?? 'Cancelar'}</Button>
            </div>

            <div className="col-md-12 mb-12">
                <DataGridComponent
                    hideFooter={props.gridHideFooter}
                    hideEdit={props.gridHideEdit ?? false}
                    hideButtons={props.hideButtons ?? false}
                    fieldId={props.gridFieldId}
                    height={props.gridHeight ?? '100%'}
                    paginationSide='client'
                    rows={props.gridRows}
                    columns={props.gridColumns}
                    onEditAction={addOrAlter}
                    onDeleteAction={deleteItemGrid}
                    minWidthGridActionsArea={props.minWidthActionsArea}
                    atualizaListaBuscaCallBack={() => { }} />
            </div>
        </div>
    )
}

export default DataGridCrudComponent;